const PUPPY_CARE_INFO = [
    {
      title: "Warmth and Comfort",
      description: "Puppies cannot regulate their body temperature, so ensure their environment is warm (around 30°C for the first week, gradually reducing to 26°C by the second week). Use heating pads or lamps, but make sure they can move away if they get too warm."
    },
    {
      title: "Feeding",
      description: "Puppies need to feed frequently, especially in the first few weeks. If the mother is unavailable, bottle-feed them with a vet-recommended puppy formula. Monitor their weight daily to ensure healthy growth."
    },
    {
      title: "Hygiene",
      description: "Keep their bedding clean and dry. Change it daily to prevent infections and maintain a healthy environment."
    },
    {
      title: "Socialization",
      description: "Begin gentle handling and exposure to different sounds, smells, and textures from an early age to promote healthy social development."
    },
    {
      title: "Health Monitoring & Vaccinations",
      description: "Schedule regular veterinary check-ups to ensure they are healthy and up-to-date on vaccinations. Watch for any signs of illness or abnormalities. 1st Vaccination: 6-8 weeks of age, 2nd Vaccination: 10-12 weeks, 3rd Vaccination: 14-16 weeks."
    },
    {
      title: "Weaning",
      description: "Start transitioning them to solid food around 3-4 weeks of age. Use high-quality puppy food and introduce it gradually."
    },
    {
      title: "Safety",
      description: "Create a safe, enclosed space for the puppies to prevent accidents and ensure they are secure."
    }
  ];
  

  export default PUPPY_CARE_INFO;